<div *ngIf="filters && filters.criteria.length > 0">
  <div class="header">{{ 'activeFilters' | translate }} ({{filters.criteria.length}})</div>
  <!-- <ul>
    <li *ngFor="let filter of filters.criteria">
      <span>{{ filter.fieldName | translate }} - </span>
      <span class="lowercase">{{ filter.operator | translate }}</span>
      <span *ngIf="filter.value && filter.value.trim()"> - {{ filter.value }}</span>
      <span *ngIf="filter.start"> - {{ filter.start | stringDate }} - </span>
      <span *ngIf="filter.end">{{ filter.end | stringDate }}</span>
    </li>
  </ul> -->
</div>